<!-- eslint-disable max-len -->
<template>
  <div
    :class="{
      'object-container-automation' : !onProperties,
      'object-active' : blockActive || (!onProperties && id === propertiesIDBlock),
      'object-disabled': !onProperties && isDisableBlock,
    }"
    class="position-relative"
    style="cursor:default"
    @mouseover="pauseZoom"
    @mouseleave="resumeZoom"
  >
    <!-- Disable Block -->
    <div
      v-if="onProperties"
      class="toggle-disable-block"
      style="top: -32px"
    >
      <j-switch v-model="disable_block" />

      <!-- Tooltip -->
      <div class="tooltip-toggle-disable">
        {{ disable_block ? 'Disable' : 'Enable' }} this block
      </div>
    </div>

    <template v-if="!onProperties">
      <img
        src="@/assets/new-form-ui/dragged.svg"
        class="icon-drag"
      >
      <img
        :src="require('@/assets/automation/while.svg')"
        width="20"
        height="20"
        class="m__r--5">
      <span class="title-automation m__r--5">WHILE</span>
      <span class="id-block-automation">{{ dataEdit ? `#${dataEdit.id}` : '' }}</span>
    </template>
    <img
      v-if="!onProperties"
      :src="require('@/assets/automation/config.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer"
      @click="showProperties">

    <div v-if="onProperties">
      <b-form-group :class="{'error-input' : $v.data_while.variable_source.$error}">
        <label> Variable Source </label>
        <j-input
          v-model="$v.data_while.variable_source.$model"
          :error-required="$v.data_while.variable_source.$error"
          :max-length="255"
          placeholder="Variable Source"/>
      </b-form-group>

      <hr>
      <span class="title-automation">Container</span>
      <b-form-group :class="{'error-input' : $v.data_while.variable_name.$error}">
        <label> Variable Name </label>
        <j-input
          v-model="$v.data_while.variable_name.$model"
          :error-required="$v.data_while.variable_name.$error"
          :max-length="255"
          placeholder="Variable Name"/>
      </b-form-group>
    </div>
    <div v-else>
      <div class="trigger__label-variable ellipsis m__t--10">
        <img
          :src="require('@/assets/automation/variable.png')"
          width="20"
          height="20"
          class="m__r--10">
        {{ dataEdit ? dataEdit.container_variable : '' }}
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-console, no-nested-ternary */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';
import jSwitch from '@/components/inputs/jSwitch';
// Mixins
import jMixPanZoom from '@/mixins/visual-programming/jMixPanZoom';
import jMixAutomation from '@/mixins/visual-programming/jMixAutomation';

export default {
  name: 'JAutomationWhile',
  components: {
    jSwitch,
  },
  mixins: [
    jMixPanZoom,
    jMixAutomation,
  ],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
    dataIndexParent: {
      type: Number,
      default: 0,
    },
    dataPosition: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    onProperties: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data_while: {
        variable_source: '',
        variable_name: '',
        is_disable: false,
      },
      disable_block: false,
      blockActive: false,
      blockError: false,
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened', 'propertiesIDBlock']),
  },
  watch: {
    dataEdit() {
      this.setValueOnProperties();

      // Set disable block according to parent
      this.updateIsDisableBlock();
    },

    propertiesOpened(val) {
      if (!val) this.blockActive = false;
    },

    // eslint-disable-next-line
    'data_while.variable_name': function (val) {
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_while.variable_name = val.replace(regexSymbol, '').replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line func-names
    'data_while.is_disable': function (val) {
      this.disable_block = !val;
    },

    disable_block(val) {
      this.data_while.is_disable = !val;
    },
  },
  created() {
    this.setValueOnProperties();
  },
  mounted() {
    // Set disable block according to parent
    this.updateIsDisableBlock();
  },
  methods: {
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened']),

    setValueOnProperties() {
      this.data_while.variable_source = this.dataEdit && this.dataEdit.while ? this.dataEdit.while.variable_source : '';
      this.data_while.variable_name = this.dataEdit ? this.dataEdit.container_variable : '';
      this.blockError = false;
      this.data_while.is_disable = this.dataEdit ? this.dataEdit.is_disable : false;
      this.disable_block = !this.data_while.is_disable;
    },

    validateData() {
      this.$v.data_while.$touch();
      return this.$v.data_while.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        if (!this.validateData()) {
          const data = {
            type: 'while',
            while: {
              variable_source: this.data_while.variable_source,
              action_while: [],
              action_done: [],
            },
            is_disable: this.data_while.is_disable,
            container_variable: this.data_while.variable_name,
          };
          if (this.dataEdit && this.dataEdit.id) data.id = this.dataEdit.id;
          resolve(data);
        } else {
          reject(null);
        }
      });
    },

    showProperties() {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({
          open: false,
        });

        setTimeout(() => {
          this.blockActive = true;
          this.setPropertiesOpened({
            open: true,
            type: 'while',
            data: this.dataEdit,
            index: this.dataIndex,
            row: this.row,
            dataParent: this.dataParent,
            idBlock: this.id,
          });
        }, 100);
      } else {
        this.blockActive = true;
        this.setPropertiesOpened({
          open: true,
          type: 'while',
          data: this.dataEdit,
          index: this.dataIndex,
          row: this.row,
          dataParent: this.dataParent,
          idBlock: this.id,
        });
      }
    },

    setErrorBlock() {
      this.blockError = true;
    },

    clearErrorBlock() {
      this.blockError = false;
    },
  },
  validations() {
    return {
      data_while: {
        variable_source: {
          required,
        },
        variable_name: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPBlockWhile.vue